import { FiMinus } from '@react-icons/all-files/fi/FiMinus'
import { FiPlus } from '@react-icons/all-files/fi/FiPlus'
import { FiPlusCircle } from '@react-icons/all-files/fi/FiPlusCircle'

// controlling some numeric value (increase, decrease), adding or removing something (eg. in a list)

export const IconAdd = FiPlus
export const IconPlus = FiPlus
export const IconMinus = FiMinus
export const IconRemove = FiMinus

export const IconAddCircle = FiPlusCircle
